import styled from 'styled-components';

export const Container = styled.div`
  .box {
    border-radius: 20px;
  }
`;
